import React from 'react'
import {applicationStyles, colors} from 'themes'
import PageTitle from 'components/base/pageTitle'
import presets from 'lib/presets'
const FaLinkedinSquare = require('react-icons/lib/fa/linkedin-square')
import team from 'lib/team'

const styles = {
  headshot: {
    width: '90%',
    maxWidth: 200,
  },
  personOuter: {
    display: 'flex',
    flexDirection: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    marginBottom: 60,
    [presets.Tablet]: {
      flexDirection: 'row',
    },
  },
  textHolder: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    marginTop: 20,
    paddingTop: 20,
    borderTop: `3px solid ${colors.green}`,
    borderLeft: 0,
    alignSelf: 'stretch',
    flex: 1,
    textAlign: 'center',
    [presets.Tablet]: {
      marginLeft: 20,
      paddingLeft: 20,
      borderLeft: `3px solid ${colors.green}`,
      borderTop: 0,
      paddingTop: 0,
      marginTop: 0,
      textAlign: 'left',
    },
  },
  nameHolder: {
    width: '100%',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    [presets.Tablet]: {
      justifyContent: 'flex-start'
    }
  },
  name: {
    fontSize: 24,
    fontWeight: 'bold',
    margin: 0,
    marginBottom: 5,
    display: 'inline-block',
  },
  title: {
    fontSize: 12,
    margin: 0,
  },
  bio: {
    textAlign: 'left',
  },
}

const person = (data) => (
  <div css={styles.personOuter}>
      <img src={data.image} css={styles.headshot}/>
      <div css={styles.textHolder}>
        <span css={styles.nameHolder}>
          <p css={styles.name}>{data.name}</p>
          <a href={data.linkedin}>
            <FaLinkedinSquare
              color={colors.green}
              size={24}
              style={{ marginLeft: 10}}
            />
          </a>
        </span>
        <p css={styles.title}>{data.title}</p>
        <p css={styles.bio}>{data.bio}</p>
      </div>
  </div>
)

const Team = () => {
  const peopleElements = team.map(data => person(data))
  return (
    <div>
      <PageTitle title='Meet the Team' />
      <div css={{...applicationStyles.mainTextContainer, padding: 0}}>
        {peopleElements}
      </div>
    </div>
  )
}
  

export default Team



// WEBPACK FOOTER //
// ./src/pages/team.js